'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CALYPSO, CALYPSO_DARK, OLAF } from 'HubStyleTokens/colors';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { SMALL_RESPONSIVE_SIZE } from './constants';
import { Fragment, useState } from 'react';
import { HorizontalInsertDropTarget, BALL_RADIUS, OUTLINE_DELTA } from '../InsertDropTargets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RoundedDiv = styled.div.withConfig({
  displayName: "RoundedButton__RoundedDiv",
  componentId: "erlmsi-0"
})([".hs-private.hs-private.hs-private &{position:relative;box-sizing:border-box;width:fit-content;border-radius:", ";padding:6px;font-size:14px;text-align:center;z-index:4;cursor:pointer;transition:transform 0.5s;transform:scale(1.000001);color:", ";background-color:", ";}.hs-private.hs-private.hs-private &:hover{background-color:", ";color:", ";transform:scale(1.05);}.hs-private.hs-private.hs-private &:active{background-color:#17839a;transition:background-color 100ms;}.hs-private.hs-private.hs-private & span.rounded-button-text{position:relative;top:-2px;left:2px;display:inline-block;padding-right:0.5em;}"], props => props.shouldRenderWithText ? '20px' : '50%', OLAF, CALYPSO, CALYPSO_DARK, OLAF);
const RoundedButton = props => {
  const {
    top,
    left,
    iconName,
    onClick,
    responsiveSize,
    label,
    useHighlightLine,
    highlightTop,
    highlightLeft,
    highlightWidth,
    testId = 'layout-dnd-rounded-button'
  } = props;
  const shouldRenderWithText = responsiveSize !== SMALL_RESPONSIVE_SIZE && label;
  const [hovered, setHovered] = useState(false);
  const offsetWidth = Math.round(highlightWidth - BALL_RADIUS - OUTLINE_DELTA);
  const offsetLeft = Math.round(highlightLeft + BALL_RADIUS / 2);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(RoundedDiv, {
      "data-transition-wrapper": true,
      shouldRenderWithText: shouldRenderWithText,
      style: {
        top,
        left
      },
      onClick: onClick,
      onMouseEnter: () => setHovered(true),
      onMouseLeave: () => setHovered(false),
      "data-test-id": testId,
      children: [iconName && /*#__PURE__*/_jsx(UIIconCircle, {
        name: iconName,
        borderWidth: 0,
        size: 14,
        padding: 0.5,
        verticalAlignment: 'center'
      }), shouldRenderWithText && /*#__PURE__*/_jsxs("span", {
        className: "rounded-button-text",
        children: [" ", label]
      })]
    }), hovered && useHighlightLine && /*#__PURE__*/_jsx(HorizontalInsertDropTarget, {
      top: highlightTop,
      left: offsetLeft,
      width: offsetWidth
    })]
  });
};
RoundedButton.propTypes = {
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  useHighlightLine: PropTypes.bool,
  highlightTop: PropTypes.number,
  highlightLeft: PropTypes.number,
  highlightWidth: PropTypes.number,
  iconName: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  responsiveSize: PropTypes.string,
  testId: PropTypes.string
};
export default RoundedButton;